import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Formik, Form, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';

import { CleanCenteredPage } from 'components/PageLayout/CleanCenteredPage';
import { Input } from '@app/form';
import { useToast, SubmitButton } from '@app/core';
import { useSendForgottenPasswordEmail } from '@app/api';

const initialValues = { email: '' };

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required(),
});

export const ForgottenPasswordRequest = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const navigate = useNavigate();

  const { mutateAsync: sendForgottenPasswordLink } =
    useSendForgottenPasswordEmail();

  const sendForgottenPasswordEmail = async (
    values: typeof initialValues,
    formikHelpers: FormikHelpers<typeof initialValues>,
  ) => {
    try {
      await sendForgottenPasswordLink(values);
      navigate('../success');
    } catch (e) {
      formikHelpers.setStatus(e);
      toast.exception();
    }
    formikHelpers.setSubmitting(false);
  };

  return (
    <CleanCenteredPage
      withPrevious
      title={t('forgottenPassword.request.title')}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={sendForgottenPasswordEmail}
        validationSchema={validationSchema}
      >
        <Form>
          <Input
            label={t('form.account.email')}
            placeholder="Ex: albert.einstein@gmail.com"
            name="email"
          />
          <SubmitButton>
            <Trans i18nKey="forgottenPassword.request.submit" />
          </SubmitButton>
        </Form>
      </Formik>
    </CleanCenteredPage>
  );
};
